const $ = jQuery.noConflict();

'use strict';
const CaseStudyListing = {

	$domCatDropdown: null,
	$domDropdownName: null,
	$domListingBlock: null,
	$domLoadMore: null,
	$domLoader: null,
	caseStudies: null,
	filteredCaseStudies: null,
	page: 1,
	offset: 6,

	init: ()=> {
		if ($('.js-case-study-listing').length < 1) {
			return;
		}
		CaseStudyListing.initValues();
		CaseStudyListing.bindEvents();
		CaseStudyListing.triggerDefaultFilter();
	},

	initValues: ()=> {
		CaseStudyListing.$domCatDropdown = $('.js-cat-dropdown');
		CaseStudyListing.$domDropdownName = $('.js-dropdown-name');
		CaseStudyListing.$domListingBlock = $('.js-case-studies-listing');
		CaseStudyListing.$domLoadMore = $('.js-load-more');
		CaseStudyListing.$domLoader = $('.js-loader');
		CaseStudyListing.caseStudies = window.fwsCaseStudies;
	},

	bindEvents: ()=> {
		CaseStudyListing.$domCatDropdown.on('click', (event)=> {
			CaseStudyListing.reset();
			CaseStudyListing.dropdownEvent(event);
		});
		CaseStudyListing.$domLoadMore.on('click', ()=> CaseStudyListing.loadMoreEvent());
	},

	triggerDefaultFilter: ()=> {
		CaseStudyListing.filteredCaseStudies = CaseStudyListing.filterPostsByTermIds([0]);

		CaseStudyListing.renderPosts(
			CaseStudyListing.preparePosts(CaseStudyListing.filteredCaseStudies)
		);
		CaseStudyListing.showLoadMore(CaseStudyListing.filteredCaseStudies.length > CaseStudyListing.offset);
	},

	dropdownEvent: (event)=> {
		const termId = $(event.currentTarget).attr('id');
		const name = $(event.currentTarget).text();

		// change dropdown name
		CaseStudyListing.changeName(name);

		// prepared posts
		CaseStudyListing.filteredCaseStudies = CaseStudyListing.filterPostsByTermIds(
			[parseInt(termId ? termId : 0)]
		);

		// render posts
		CaseStudyListing.renderPosts(
			CaseStudyListing.preparePosts(
				CaseStudyListing.filteredCaseStudies
			)
		);
	},

	changeName: (name)=> {
		CaseStudyListing.$domDropdownName.text(name);
	},

	loadMoreEvent: ()=> {
		CaseStudyListing.page++;
		CaseStudyListing.renderPosts(
			CaseStudyListing.preparePosts(
				CaseStudyListing.filteredCaseStudies
			)
		);
	},

	filterPostsByTermIds: (termIds) => {
		if (termIds.includes(0)) {
			return CaseStudyListing.caseStudies;
		}

		return CaseStudyListing.caseStudies.filter(post =>
			post.term_ids.some(termId => termIds.includes(termId))
		);
	},

	preparePosts: (posts)=> {
		const start = (CaseStudyListing.page - 1) * CaseStudyListing.offset;
		const end = start + CaseStudyListing.offset;
		return posts.slice(start, end);
	},

	renderPosts: (posts)=> {
		if (posts.length === 0) {
			CaseStudyListing.noResults();
			CaseStudyListing.showLoadMore(false);
			return;
		}

		// CaseStudyListing.showLoader(true);
		for (let i = 0; i < posts.length; i++) {
			CaseStudyListing.$domListingBlock.append(
				CaseStudyListing.postTemplate(posts[i])
			);
		}

		CaseStudyListing.showLoadMore((CaseStudyListing.page * CaseStudyListing.offset) < CaseStudyListing.filteredCaseStudies.length);
		// CaseStudyListing.showLoader(false);
	},

	postTemplate: (post)=> {
		return `
			<div class="case-studies-listing__item">
			  <div class="case-study-tile">
				<div class="case-study-tile__image media-wrap--lazy-thumb media-wrap media-wrap--648x440 is-hidden">
				  <img class="media-item cover-img lazy entered loaded" src="${post.image}" data-src="${post.image}" alt="${post.title}" data-ll-status="loaded">
				</div>
				<div class="case-study-tile__content">
				  <h3 class="case-study-tile__title">${post.title}</h3>
				  <p class="case-study-tile__text">${post.description.substring(0, 200)}${post.description.length > 200 ? '...' : ''}</p>
				  <a class="case-study-tile__link btn btn--link btn--txt-icon btn--progress btn--arrow" href="${post.permalink ? post.permalink : 'javascript:;'}">
					Read full case study
					<span class="btn-icon svg-icon">
					  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
						<path d="M3.913 2.408l.006.006a12.044 12.044 0 008.197 2.556l1.67-.102L.723 17.931l1.344 1.344L15.131 6.21l-.102 1.67a12.101 12.101 0 002.222 7.755l.008.008.019.028.013.018c.252.348.523.682.811 1l1.342-1.341c-3.327-3.765-3.376-9.457-.145-13.257L17.91.7C14.108 3.933 8.418 3.885 4.652.556L3.31 1.898c.183.166.369.323.557.47l.012.013.015.01c.007.007.013.011.021.017h-.002z"></path>
					  </svg>
					</span>
				  </a>
				</div>
			  </div><!-- .case-study-tile -->
			</div>
		`;
	},

	noResults: ()=>{
		CaseStudyListing.$domListingBlock.append('<div class="case-studies-listing__no-results">No results were found!</div>');
	},

	reset: ()=> {
		CaseStudyListing.$domListingBlock.empty();
		CaseStudyListing.page = 1;
	},

	showLoader: (status)=>{
		CaseStudyListing.$domLoader.toggleClass('active', status);
	},

	showLoadMore: (show)=> {
		CaseStudyListing.$domLoadMore.css('display', show ? 'block' : 'none');
	},
};

export default CaseStudyListing;
